import React, { useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import newsData from '../news.json';

const NewsDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { news, footer } = newsData;

  // 页面加载时滚动到顶部
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);

  // 查找当前新闻
  const currentNews = news.find(item => item.id === id);

  // 如果找不到新闻，返回新闻列表
  if (!currentNews) {
    return (
      <div className="pt-[60px] min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900 mb-4">新闻未找到</h1>
          <Link to="/news" className="text-[#1a5681] hover:underline">返回新闻列表</Link>
        </div>
      </div>
    );
  }

  return (
    <main className="pt-[60px] min-h-screen bg-white">
      {/* Back Navigation */}
      <section className="py-4 bg-white border-b border-gray-100">
        <div className="container mx-auto px-6">
          <button 
            onClick={() => navigate('/news')}
            className="flex items-center gap-2 text-gray-500 text-sm hover:text-[#1a5681] transition-colors"
          >
            <span className="material-symbols-outlined text-sm">arrow_back</span>
            <span>BACK TO NEWS</span>
          </button>
        </div>
      </section>

      {/* Article Header */}
      <section className="py-8 bg-white">
        <div className="container mx-auto px-6">
          <div className="flex items-center gap-3 mb-4">
            <span className="text-[#1a5681] text-xs font-bold tracking-wider">{currentNews.category}</span>
            <span className="text-gray-400 text-sm">{currentNews.date}</span>
          </div>
          <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">{currentNews.title.en}</h1>
          <p className="text-gray-600 text-lg">{currentNews.title.zh}</p>
        </div>
      </section>



      {/* Article Content */}
      <section className="pb-12">
        <div className="container mx-auto px-6">
          <div className="max-w-3xl mx-auto">
            {/* Main Content */}
            <div className="prose prose-lg max-w-none mb-12">
              <p className="text-gray-700 leading-relaxed mb-6">{currentNews.content.en}</p>
              <p className="text-gray-600 leading-relaxed">{currentNews.content.zh}</p>
            </div>

            {/* Highlights */}
            {currentNews.highlights && currentNews.highlights.map((highlight, index) => (
              <div key={index} className="bg-gray-50 rounded-lg p-6 mb-8">
                <div className="flex items-start gap-6">
                  <div className="flex-shrink-0">
                    <div className="text-4xl font-bold text-[#1a5681]">{highlight.value}</div>
                    <div className="text-xs text-gray-500 tracking-wider mt-1">{highlight.label}</div>
                  </div>
                  <div className="flex-1 border-l border-gray-200 pl-6">
                    <h3 className="text-lg font-bold text-gray-900 mb-2">{highlight.title}</h3>
                    <p className="text-gray-600 text-sm leading-relaxed">{highlight.description.en}</p>
                    <p className="text-gray-500 text-xs mt-2 leading-relaxed">{highlight.description.zh}</p>
                  </div>
                </div>
              </div>
            ))}

            {/* Conclusion */}
            <div className="border-t border-gray-200 pt-8">
              <p className="text-gray-700 leading-relaxed mb-4">{currentNews.conclusion.en}</p>
              <p className="text-gray-600 leading-relaxed">{currentNews.conclusion.zh}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-50 py-8 border-t border-gray-200">
        <div className="container mx-auto px-6">
          <div className="flex flex-col items-center justify-center gap-4">
            <p className="text-gray-400 text-xs text-center">{footer.copyright}</p>
            <p className="text-gray-400 text-xs text-center">
              <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" className="hover:underline">
                {footer.beian}
              </a>
            </p>
          </div>
        </div>
      </footer>
    </main>
  );
};

export default NewsDetail;
